import Cookies from 'js-cookie'
import { useCallback } from 'react'

import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_DISABLE_TOTP } from '@/app/module/user/definitions'
import { getUser } from '@/app/module/user/store/actions'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useDisableTotp = () => {
  const dispatch = useAppDispatch()
  const [mutate, res] = esApi.useDisableUserTotpMutation()

  const disableTotp = useCallback(async () => {
    try {
      await mutate().unwrap()
      const token = Cookies.get('authToken') || ''
      if (token) {
        await dispatch(getUser({ token }))
      }
      return true
    } catch (error) {
      dispatch(
        createNotification({
          'disable-totp': {
            type: 'error',
            message: getErrorMessage(error, ERROR_DISABLE_TOTP),
          },
        }),
      )
      return false
    }
  }, [dispatch, mutate])

  return [disableTotp, res] as const
}
